<template>
  <div>
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb
            :link="[{ name: 'Quản lý Báo giá', active: true }]"
          ></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter pb-3">
      <block
        :nobody="true"
        ref="bscantem"
        class="soft-control"
        :style="`min-height:${$hControl - 30}px`"
      >
        <div class="d-block">
          <StreamBarcodeReader
            @decode="onDecode"
            @loaded="onLoaded"
          ></StreamBarcodeReader>
        </div>
        <div v-if="!isScanner">
          <h5 class="m-5 text-center">
            THIẾT BỊ CỦA BẠN KHÔNG HỖ TRỢ QUÉT TEM
          </h5>
        </div>
        <div class="row justify-content-center">
            <div class="col-6">
              <div class="border border-primary p-4">
                <div class="text-center">
                  <base-input
                    v-model="temcode"
                    class="mt-2"
                    placeholder="Nhập mã tem thủ công"
                    style="width:90%; margin:auto"
                  ></base-input>
                  <b-button
                    class="mt-2"
                    variant="success"
                    @click="inputTemMantua"
                  >
                    Nhập code thủ công
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        <b-row align-h="center" align-v="center">
          <b-col md="4">
            <base-input
              v-model="quantity"
              :mask="'number'"
              class="mt-2"
              placeholder="Nhập số lượng muốn nhập kho"
              style="width:90%; margin:auto"
            ></base-input>
            <b-button class="mb-2" block="" variant="success" @click="doVerify">
              Xác nhận đã nhập kho
            </b-button>
          </b-col>
        </b-row>
        <div v-if="tem && tem.id" class="table-responsive mb-3">
          <table class="table">
            <tr>
              <td style="width:80px; padding-left:0px; padding-right:0px">
                <barcode
                  v-bind:value="tem.code"
                  height="30"
                  width="1"
                  fontSize="12"
                >
                  Lỗi render code
                </barcode>
              </td>
              <td>
                <span class="d-flex">
                  Mã LCT: <b>{{ tem.code }}</b>
                </span>
                <div class="d-flex">
                  SL Sản xuất :
                  <b>{{ $formatNumber(tem.manufature.quantityProduce) }}</b>
                </div>
                <div class="d-flex">
                  NSX :
                  <b>{{ $dateUnix(tem.manufature.dateCreated) }}</b>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Mã SP: <b>{{ tem.manufature.product.code }}</b>
              </td>
              <td>
                Tên SP: <b>{{ tem.manufature.product.name }}</b>
              </td>
            </tr>
            <tr>
              <td>
                Màu sắc : <b>{{ tem.manufature.colorText }}</b>
              </td>
              <td>
                Quy cách : <b>{{ tem.manufature.productSpecify.name }}</b>
              </td>
            </tr>
            <tr></tr>
          </table>
        </div>
        <div v-else>
          <b-alert
            style="width:80%; margin:auto;"
            class="mb-3"
            show
            variant="info"
          >
            quét để xác nhận tem</b-alert
          >
        </div>
      </block>
    </div>
  </div>
</template>
<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
import { temService } from "@/_services";
import { receiptService } from "@/_services";

import VueBarcode from "vue-barcode";

const srcDone = require("@/assets/sound/done.wav");
export default {
  name: "scanner-tem",
  components: {
    StreamBarcodeReader,
    barcode: VueBarcode
  },
  data: () => ({
    loading: true,
    lastIndexCustomerSelected: 0,
    info: {},
    tableData: [],
    isScanner: false,
    quantity: 0,
    temcode: "",
    listResults: [],
    tem: {},
    audio: {
      scanDone: new Audio(srcDone)
    }
  }),

  methods: {
    onDecode(result) {
      var self = this;
      if (!this.listResults.includes(result)) {
        console.log("onDecode", result);
        temService.getTemScanner(result).then(res => {
          self.tem = res.data;
          self.audio.scanDone.pause();
          self.audio.scanDone.play();
        });
      } else {
        this.$alertify.warning(
          "Tem này đã quét rồi, mỗi tem chỉ được quét 1 lần thôi",
          {
            duration: 4000
          }
        );
      }
    },
    inputTemMantua() {
      var self = this;
      if (!this.listResults.includes(this.temcode)) {
        console.log("inputTemMantua", this.temcode);
        temService.getTemScanner(this.temcode).then(res => {
          self.tem = res.data;
        });
      } else {
        this.$alertify.warning(
          "Tem này đã quét rồi, mỗi tem chỉ được quét 1 lần thôi",
          {
            duration: 4000
          }
        );
      }
      this.temcode = "";
    },
    doVerify() {
      if (!this.tem || !this.tem.id) {
        this.$alertify.warning("Chưa có tem nào để nhập", {
          duration: 4000
        });
      } else {
        this.$refs.bscantem.block();
        receiptService
          .verifyIn(this.tem, this.quantity)
          .then(res => {
            this.$alertify.success(res.message, {
              duration: 4000
            });
            this.tem = {};
            this.quantity = 0;
          })
          .finally(() => {
            this.$refs.bscantem.unBlock();
          });
      }
    },
    onLoaded(result) {
      this.isScanner = true;
      console.log("onLoaded", result);
    }
  }
};
</script>
<style lang="scss">
.scanner-container {
  video {
    height: 150px;
    margin: 0 auto;
    display: table;
    width: 100%;
    object-fit: cover;
  }
}
</style>
